import React from 'react';
import { useTranslation } from 'react-i18next';

const TiptapViewer = ({
    content,
    emptyText,
    className = ""
}) => {
    const { t } = useTranslation("layout");
    const createMarkup = (html) => {
        return { __html: html };
    };

    if (!content) {
        return <p className="text-muted mb-0">{emptyText ?? t("tiptapViewer.empty")}</p>;
    }

    return (
        <div
            className={`tiptap-content ${className}`}
            dangerouslySetInnerHTML={createMarkup(content)}
            style={{ lineHeight: '1.6' }}
        />
    );
};

export default TiptapViewer;
